<snowylive-header title="Contact Us" icon="call-outline"></snowylive-header>

<ion-content [fullscreen]="true" color="light">
  <ion-card class="detail-card" color="light">
    <ion-card-content>
      <div [innerHTML]="contactUsRichText"></div>
    </ion-card-content>
  </ion-card>
</ion-content>
